import { Component, EventEmitter, Input, output, Output } from '@angular/core';

import { PositionTooltipType } from '../awesome-tooltip-v2/awesome-tooltip-v2.directive';
import { AwesomeTooltipV2Module } from '../awesome-tooltip-v2/awesome-tooltip-v2.module';

type ColorType = 'primary' | 'secondary' | 'positive' | 'negative' | 'tertiary';
type TypeButton = 'filled' | 'transparent';

@Component({
  selector: 'app-icon-button-v2',
  imports: [AwesomeTooltipV2Module],
  standalone: true,
  templateUrl: './icon-button-v2.component.html',
  styleUrl: './icon-button-v2.component.scss',
})
export class IconButtonV2Component {
  // Button options
  @Input() disabled: boolean = false;
  @Input() icon?: string = '';
  @Input() color: ColorType = 'primary';
  @Input() type: TypeButton = 'filled';
  @Input() size: 'large' | 'medium' | 'small' = 'large';
  @Input() iconsSize: 'fz20' = null;
  @Input() textAlign: 'center' | 'left' = 'center';
  @Input() isLoading: boolean = false;
  @Input() active: boolean = false;
  @Input() isHovered: boolean = false;
  @Input() disabledHover: boolean = false;
  btnClickSignal = output();
  @Output() btnClick = new EventEmitter<void>();
  // Tooltip options
  @Input() positionTooltip: PositionTooltipType = 'topCenter';
  @Input() actions: boolean = false;
  @Input() tooltipText: string = null;

  onClick() {
    this.btnClickSignal.emit();
    this.btnClick.emit();
  }
}
